/*
 *
 * Date: 2025
 * Description: Log box for all scripts logs, permits to select wich script to see its logs
 * Author: Philippe Leroux @SKITSC
 *
 */


//Modules
import { Box , IconButton } from "@mui/material"
import { ReactElement } from "react";

//Utils
import { timestampToDate } from "../../utils/utility";

//Components
import Tbl from "../table/main.table";

//Interfaces
import { i_script_info } from "../../interfaces/utility.interface";
import { i_archive_box_props } from "../../interfaces/display.interfaces";

//Icons
import HideSourceIcon from '@mui/icons-material/HideSource';

const ArchiveBox = ( props : i_archive_box_props) : ReactElement => {
    return (
        <Box>
            <Box sx={{ display : 'flex' , flexDirection : 'column' , border : '1px solid black' }}>
                <Box sx={{ maxHeight : '300px' , overflowY : 'scroll'}}>
                    <Tbl {...props.table} />
                </Box>
                {props.selected !== null &&
                    <Box sx={{ minHeight : '400px' , overflowY : 'scroll' , backgroundColor : '#111' , marginTop : '1vh' , position : 'relative'}}>
                        <Box sx={{display : 'flex' , justifyContent : 'flex-end'}}>
                            <IconButton onClick={() => props.clear()} sx={{ position: 'absolute', top: 4, right: 4, color: 'red', }}><HideSourceIcon sx={{ color : 'red' }}/></IconButton>
                        </Box>
                        {
                            props.selected !== null && props.selected.row.map((log : i_script_info, index : number) => (
                                <Box key={index} sx={{ padding : '4px 8px' , color : log.event === 'data' ? 'lime' : log.event === 'error' ? 'red' : 'orange' }}>{log.msg} - {timestampToDate( log.time , 'short' )}</Box>
                            ))
                        }
                    </Box>
                }
            </Box>
        </Box>
    )
}


export default ArchiveBox;